import type { AuthContextState } from '@opendoor/auth-fe/context';

import { requestZeusFromBrowser } from '../api/zeusBrowserClient';
import { AccountMarketingSmsPreferenceUpdateDocument } from './__generated__/registrationSmsConsent.zeus';

export const recordRegistrationSmsConsent: AuthContextState['recordMarketingSmsConsent'] = async ({
  consentLanguage,
  email,
  optIn,
}) => {
  try {
    const response = await requestZeusFromBrowser(AccountMarketingSmsPreferenceUpdateDocument, {
      input: {
        consentLanguageVersion: consentLanguage,
        expectedEmail: email,
        marketingSmsOptedOut: !optIn,
        source: 'COSMOS',
      },
    });

    const result = response.accountMarketingSmsPreferenceUpdate;
    switch (result['__typename']) {
      case 'CommunicationPreferences':
        return { success: true };
      case 'NotFoundError':
      case 'UnauthorizedError':
      case 'InvalidInputError':
        return { success: false };
      default:
        result satisfies never;
        return { success: false };
    }
  } catch {
    return { success: false };
  }
};
